import { useEffect, useRef, useState } from "react";

const useUploadedImagesHook = ({ images, handleDeleteImage }) => {
  const [photoIndex, setPhotoIndex] = useState(0); // Current image index in lightbox
  // Lightbox state management
  const [open, setOpen] = useState(false); // Lightbox open/close state
  const menuRef = useRef(null); // Reference to dropdown menu container
  const [openMenuId, setOpenMenuId] = useState(null); // ID of currently open menu dropdown
  const buttonRef = useRef(null); // Reference to menu trigger button

  const getActiveImageId = () => images[photoIndex]?.id;

  const handleDeleteFromLightbox = () => {
    const imageId = getActiveImageId();
    if (!imageId) return;
    handleDeleteImage(imageId);
  };

  // Handler for opening lightbox when an image is clicked
  const handleImageClick = (index) => {
    setPhotoIndex(index); // Set the clicked image as current
    setOpen(true); // Open the lightbox
  };

  useEffect(() => {
    const handleClickOutside = (event) => {
      if (
        menuRef.current &&
        !menuRef.current.contains(event.target) &&
        buttonRef.current &&
        !buttonRef.current.contains(event.target)
      ) {
        setOpenMenuId(null);
      }
    };

    document.addEventListener("mousedown", handleClickOutside);

    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, [openMenuId]);

  return {
    photoIndex,
    setPhotoIndex,
    handleDeleteFromLightbox,
    open,
    setOpen,
    handleImageClick,
    menuRef,
    openMenuId,
    setOpenMenuId,
    buttonRef,
  };
};

export default useUploadedImagesHook;
